var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSpirits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 6H6.15625L8 8.0625L9.84375 6ZM14 2V3.34375L8.65625 9.34375V12.6562H12V14H4V12.6562H7.34375V9.34375L2 3.34375V2H14ZM4.96875 4.65625H11.0312L12.2188 3.34375H3.78125L4.96875 4.65625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSpirits);
export default __webpack_public_path__ + "static/media/ico_spirits.26f9d84549260c8ae645a6d08c959942.svg";
export { ForwardRef as ReactComponent };